import React, { memo, useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Container } from "./index.style";

const ChartEnergy = ({
  energyData = [],
  max = 0,
  total_consumed_kwh,
  estimated_cost_brl,
  height = 300, // altura fixa padrão
}) => {
  const [state, setState] = useState({
    series: [],
    options: {
      chart: {
        type: "line",
        height: height, // altura fixa
        stacked: false,
        toolbar: { show: false },
        zoom: { enabled: false },
      },
      dataLabels: { enabled: false },
      stroke: {
        width: [0, 0, 3],
        curve: "smooth",
      },
      plotOptions: {
        bar: {
          columnWidth: "70%",
          borderRadius: 4,
        },
      },
      colors: ["#008FFB", "#00E396", "#FF4560"],
      xaxis: {
        categories: [],
        labels: {
          rotate: -45,
        },
      },
      yaxis: [
        {
          title: {
            text: "Consumo / Custo",
          },
          labels: {
            formatter: (value) => {
              if (value >= 1000) {
                return (value / 1000).toFixed(1) + "k";
              }
              return Number.isInteger(value)
                ? value.toString()
                : Number(value).toFixed(2);
            },
          },
        },
      ],
      tooltip: {
        shared: true,
        intersect: false,
      },
      legend: {
        position: "top",
      },
      grid: {
        strokeDashArray: 4,
      },
    },
  });

  useEffect(() => {
    if (!energyData.length) return;

    const today = new Date().getDate();

    const filteredData = energyData.filter(
      (item) => Number(item.day) <= today
    );

    const days = filteredData.map((item) => item.day);

    const consumptionTotal = filteredData.map(
      (item) => Number(item.consumption_peak || 0) + Number(item.consumption_off_peak || 0)
    );

    const costTotal = filteredData.map(
      (item) => Number(item.cost_peak || 0) + Number(item.cost_off_peak || 0)
    );

    setState((prev) => ({
      ...prev,
      series: [
        {
          name: "Consumo (kWh)",
          type: "column",
          data: consumptionTotal,
        },
        {
          name: "Custo (R$)",
          type: "column",
          data: costTotal,
        },
        {
          name: "Meta de Consumo",
          type: "line",
          data: Array(consumptionTotal.length).fill(max),
        },
      ],
      options: {
        ...prev.options,
        chart: {
          ...prev.options.chart,
          width: Math.max(filteredData.length * 80, 600),
          height: height, // altura fixa
        },
        xaxis: {
          ...prev.options.xaxis,
          categories: days,
        },
      },
    }));
  }, [energyData, max, height]);

  return (
    <Container style={{ overflowX: "auto" }}>
        <ReactApexChart
        options={state.options}
        series={state.series}
        type="line"
        height={height}
        width="100%"
      />
          <p className="label-total">
        Valor total em kWh: <strong>{total_consumed_kwh}</strong>
      </p>

      <p className="label-total">
        Valor total estimado (R$): <strong>{estimated_cost_brl}</strong>
      </p>
    </Container>
  );
};

export default memo(ChartEnergy);